

import { GET_BRAND_REVIEWS } from '~/api/apolloBrandQueries';

import { createNamespacedHelpers } from 'vuex';
import respUtility from '@/mixins/respUtility';

const { mapState } = createNamespacedHelpers('listing');

export default {
  name: 'BrandView',
  mixins: [respUtility],
  data: () => ({
    isReviews: false,
    itemsReviewsBrand: [],
    isFirstRequestReviewsBrand: true,
    loadingReviews: 0,
    pageId: 1,
    sortMode: 'by_customer_photos',
  }),
  props: {
    footerData: {
      type: Object,
      default() {
        return {};
      },
    },
    breadcrumbs: {
      type: Array,
      default() {
        return [];
      },
    },
    itemsCount: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default() { return []; },
    },
    perPage: {
      type: Number,
      default: 36,
    },
    attrs: {
      type: Object,
      default() {
        return {};
      },
    },
    header: {
      type: String,
      default: 'brand',
    },
    isBrandPage: {
      type: Boolean,
    },
    isCollectionPage: {
      type: Boolean,
    },
    popularCollections: {
      type: Array,
      default() { return []; },
    },
    popularCollectionsAll: {
      type: Number,
      default: 0,
    },
    brandRating: {
      type: Object,
      default() { return {}; },
    },
    brandTopBanner: {
      type: Object,
      default() { return {}; },
    },
  },
  jsonld() {
    const graph = [];
    const breadcrumbs = (this.breadcrumbs || []).map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: {
        '@id': item.url,
      },
    }));
    if (breadcrumbs.length) {
      graph.push({
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs,
      });
    }
    return {
      '@context': 'https://schema.org',
      '@graph': graph,
    };
  },
  computed: {
    ...mapState(['searchParams']),
    isSearchParams() {
      let copy = this.searchParams || {};
      if (copy.facet) {
        copy = { ...copy, ...copy.facet };
        delete copy.facet;
      }
      return Boolean(Object.keys(copy).length);
    },
    isSearchFilter() {
      const copy = this.searchParams || {};
      if (copy.facet) {
        return true;
      }
      return false;
    },
    isMobile() {
      return (this.$device.isMobileOrTablet || this.isTouchDevice);
    },
    isBrandCarousel() {
      return !this.isSearchFilter && !this.isCollectionPage && this.isBrandPage;
    },
    isBrandBanner() {
      return !(this.isMobile && this.isSearchFilter && this.isBrandPage);
    },
    brandDescription() {
      return this.$store.state.metaData?.addons?.description || '';
    },
    brandTitle() {
      return this.brandTopBanner?.title || '';
    },
    brandLogo() {
      return this.brandTopBanner?.logo || {};
    },
  },
  methods: {
    toggleReviews(value) {
      this.isReviews = value;
      this.$nuxt.$emit('change-header-scrolling', !this.isReviews);
      this.$nuxt.$emit('minicart-open', this.isReviews);
      if (this.isFirstRequestReviewsBrand) {
        this.sortMode = this.brandRating?.hasImages ? 'by_customer_photos' : 'by_most_relevant';
        this.isFirstRequestReviewsBrand = false;
        this.getItemsReviewsBrand();
      }
    },
    async getItemsReviewsBrand() {
      if (this.pageId === 1) this.loadingReviews += 1;
      const defaultParams = {
        slug: this.$route.path[0] === '/' ? this.$route.path.slice(1) : this.$route.path,
        pageId: this.pageId,
        sortMode: this.sortMode,
      };
      const itemsReviewsBrand = async () => {
        const { brand } = await this.$graphql.default
          .request(GET_BRAND_REVIEWS, defaultParams) || {};
        if (this.pageId === 1) {
          this.itemsReviewsBrand = [...brand.reviews];
        } else {
          this.itemsReviewsBrand = [...this.itemsReviewsBrand, ...brand.reviews];
        }
      };
      try {
        await itemsReviewsBrand();
      } catch (e) {
        console.error(e);
      }
      if (this.pageId === 1) this.loadingReviews -= 1;
    },
    changeSort(value) {
      this.sortMode = value;
      this.pageId = 1;
      this.getItemsReviewsBrand();
    },
    changePage() {
      this.pageId += 1;
      this.getItemsReviewsBrand();
    },
  },
};
